export default class Settings {
    constructor(data) {
        this.culture = '';

        if (data) {
            Object.assign(this, data);
        }
    }
}
